import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImInfo } from "react-icons/im";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { IoMdArrowDropleft } from "react-icons/io";
import toast from "react-hot-toast";
import images from "../Resources/Images";
import { validateEmail, logout } from "../Utils/index";
import { useOutsideClick } from "../Hooks/useOutSideClic";
import { getUrl } from "../Network/urls";
import { post } from "../Network/requests";
import Loader from "./UI/Loader";
import PasswordToolTip from "./PasswordToolTip";

/* eslint-disable react/jsx-props-no-spreading */

function ForgotPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [repasswordErr, setRePasswordErr] = useState("");
  const [otpErr, setOtpErr] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRePassword] = useState("");
  const [sendotp, setSendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const containerRef = useRef(null);
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const numbersRegex = /[0-9]/;
  const specialCharsRegex = /[@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~!]/;

  let operation = "";

  const handleInputChange = (e) => {
    switch (e.target.name) {
      case "email":
        if (e.target.value === "") {
          setEmailErr("Email address is required.");
          setEmail("");
        } else if (!validateEmail(e.target.value)) {
          setEmail(e.target.value);
          setEmailErr("Please enter a valid email address.");
        } else {
          setEmailErr("");
          setEmail(e.target.value);
        }
        break;
      case "otp":
        if (e.target.value === "") {
          setOtpErr("OTP is required.");
          setOtp("");
        } else {
          setOtpErr("");
          setOtp(e.target.value);
        }
        break;
      case "password":
        if (e.target.value === "") {
          setPasswordErr("Password is required.");
          setPassword("");
        } else {
          setPasswordErr("");
          setPassword(e.target.value);
        }
        break;
      case "repassword":
        if (e.target.value === "") {
          setRePasswordErr("Confirm Password is required.");
          setRePassword("");
        } else {
          setRePasswordErr("");
          setRePassword(e.target.value);
        }
        break;
      default:
        break;
    }
  };

  const handleEnable = () => {
    setIsDisabled(!isDisabled);
  };
  const handlePasswordValidation = (pass) => {
    if (!uppercaseRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one uppercase letter."
      );
      return false;
    }
    if (!lowercaseRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one lowercase letter."
      );
      return false;
    }
    if (!numbersRegex.test(pass)) {
      setPasswordErr("The password must contain at least one number.");
      return false;
    }
    if (!specialCharsRegex.test(pass)) {
      setPasswordErr(
        "The password must contain at least one special character."
      );
      return false;
    }
    if (pass?.length < 12) {
      setPasswordErr("The password must be at least 12 characters long.");
      return false;
    }
    setPasswordErr("");
    return true;
  };

  const isEmailValidation = () => {
    let isEmailValid = true;
    if (email === "") {
      setEmailErr("Email address is required.");
      isEmailValid = false;
    }
    if (email !== "" && !validateEmail(email)) {
      setEmailErr("Please enter a valid email address.");
      isEmailValid = false;
    }
    return isEmailValid;
  };

  const isFormValidation = () => {
    let isValid = true;
    if (password === "") {
      setPasswordErr("Password is required");
      isValid = false;
    }
    if (repassword === "") {
      setRePasswordErr("Confirm Password is required");
      isValid = false;
    }
    if (repassword !== password) {
      setRePasswordErr("Confirm Password does not match");
      isValid = false;
    }
    if (otp === "") {
      setOtpErr("OTP is required");
      isValid = false;
    }
    if (!handlePasswordValidation(password.trim())) {
      setIsVisible(true); // show password info tooltip
      isValid = false;
    }
    return isValid;
  };

  const handleFormSubmit = (e) => {
    operation = "confirm_user_password";
    e.preventDefault();
    setSendOtp(true);

    const isValid = isFormValidation();
    if (isValid) {
      setIsLoading(true);
      const url = getUrl("forgot-password");
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          email: email,
          password: password,
          operation: operation,
          confirm_code: otp,
        },
      };
      const otpData = JSON.stringify(apiPayload);
      post(`${url}`, otpData, false).then((response) => {
        const {
          data: { body, statusCode },
        } = response;
        switch (statusCode) {
          case 200:
            toast.success(body.message);
            setIsLoading(false);
            navigate("/login");
            break;
          case 400:
            setIsLoading(false);
            toast.error(body.message);
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            setIsLoading(false);
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      });
    }
  };

  const handleKeyPress = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      handleFormSubmit(event);
    }
  };

  const handleSendOTP = (e) => {
    // get values of all fields in this function
    operation = "forgot_password";
    e.preventDefault();
    setSendOtp(true);

    const isEmailValid = isEmailValidation();
    if (isEmailValid) {
      setIsLoading(true);
      const url = getUrl("forgot-password");
      const apiPayload = {
        httpMethod: "POST",
        parameters: {
          source: "RegData",
          email: email,
          operation: operation,
        },
      };
      const changePasswordData = JSON.stringify(apiPayload);
      post(`${url}`, changePasswordData, false).then((response) => {
        const {
          data: { body, statusCode },
        } = response;
        switch (statusCode) {
          case 200:
            handleEnable();
            toast.success(body.message);
            setIsLoading(false);
            break;
          case 400:
            setIsLoading(false);
            toast.error(body.message);
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            setIsLoading(false);
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            break;
        }
      });
    }
  };

  const handleEmailKeyPress = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      handleSendOTP(event);
    }
  };

  useOutsideClick(containerRef, () => setIsVisible(false));

  return (
    <>
      {isLoading && <Loader />}
      <div className="forgotpwd_wrapper">
        <div style={{ position: "relative", width: "580px" }}>
          <div className="forgotpwd_inner" style={{ overflowY: "visible" }}>
            <div className="forgotpwd_header">
              <div className="forgotpwd_logo">
                <img
                  src={images.Logo}
                  alt="/logo"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <h5>Reset Password For RegData Platform</h5>
            </div>
            <div className="forgotpwd_form">
              <form id="form" className="flex flex-col">
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleEmailKeyPress}
                />
                {emailErr !== "" ? (
                  <div className="invalid-feedback d-block">{emailErr}</div>
                ) : null}

                <button
                  type="button"
                  name="sendotp"
                  value={sendotp}
                  onClick={handleSendOTP}
                  onKeyPress={handleEmailKeyPress}
                >
                  Send OTP
                </button>

                <input
                  type="text"
                  placeholder="Enter OTP"
                  name="otp"
                  value={otp}
                  disabled={isDisabled}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                  onKeyPress={handleKeyPress}
                />
                {otpErr !== "" ? (
                  <div className="invalid-feedback d-block">{otpErr}</div>
                ) : null}

                <div className="d-flex position-relative align-items-center registration-input justify-content-between">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={password}
                    className="input-outline-none"
                    disabled={isDisabled}
                    onChange={handleInputChange}
                    onBlur={() => {}}
                    onFocus={() => {}}
                  />
                  <div style={{ display: "flex", gap: "17px" }}>
                    {showPassword ? (
                      <IoEye
                        size={20}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <IoEyeOff
                        className="cursor-pointer"
                        size={20}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                    <ImInfo
                      className="cursor-pointer"
                      size={20}
                      onClick={() => setIsVisible(!isVisible)}
                    />
                  </div>
                  {isVisible && <PasswordToolTip containerRef={containerRef} />}
                </div>
                {passwordErr !== "" ? (
                  <div className="invalid-feedback d-block">{passwordErr}</div>
                ) : null}

                <input
                  type="password"
                  placeholder="Confirm New Password"
                  name="repassword"
                  value={repassword}
                  disabled={isDisabled}
                  onChange={handleInputChange}
                  onBlur={() => {}}
                  onFocus={() => {}}
                />
                {repasswordErr !== "" ? (
                  <div className="invalid-feedback d-block">
                    {repasswordErr}
                  </div>
                ) : null}

                <button
                  type="button"
                  disabled={isDisabled}
                  onClick={handleFormSubmit}
                >
                  Submit
                </button>

                <Link to="/login" onClick={() => logout()}>
                  Back
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPasswordComponent;
